module.exports = __webpack_public_path__ + "img/mt.8b37fbbb.svg";